export default function SpanishFlag(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="20"
      viewBox="0 0 27 20"
      fill="none"
    >
      <g clipPath="url(#clip0_6855_512)">
        <rect x="0.365234" y="0.617188" width="26.2691" height="18.7636" rx="3.75273" fill="#F93939" />
        <path
          d="M24.1325 0.617188H2.86705C1.48534 0.617188 0.365234 1.73729 0.365234 3.11901V16.879C0.365234 18.2607 1.48534 19.3808 2.86705 19.3808H24.1325C25.5142 19.3808 26.6343 18.2607 26.6343 16.879V3.11901C26.6343 1.73729 25.5142 0.617188 24.1325 0.617188Z"
          fill="#F93939"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.365234 5.61719H26.6343V14.3736H0.365234V5.61719Z"
          fill="#FFDA2C"
        />
      </g>
      <defs>
        <clipPath id="clip0_6855_512">
          <rect x="0.365234" y="0.617188" width="26.2691" height="18.7636" rx="3.75273" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
